import { forwardRef, useEffect, useState } from 'react';
import { PHONE_COUNTRIES, phoneCountry, nationalPhone, internationalPhone } from './phoneCountry';
import './PhoneInput.css';

/** UI-only country selection. The parent still receives one international phone string.
 * Never rewrite existing values on mount, including numbers outside the offered countries.
 * US/Canada share +1; the chosen flag is presentation state, not a new API/DB field.
 */
const PhoneInput = forwardRef(function PhoneInput({ value = '', onChange, disabled, readOnly,
  countryLabel = 'Phone country code', style, className = '', ...props }, ref) {
  const [country, setCountry] = useState(() => phoneCountry(value));
  useEffect(() => { setCountry(previous => phoneCountry(value, previous)); }, [value]);
  const emit = (event, next) => onChange?.({ ...event,
    target: { ...event.target, name: props.name, id: props.id, value: next },
    currentTarget: { ...event.currentTarget, name: props.name, id: props.id, value: next },
  });
  return <span className="milton-phone-input">
    <select aria-label={countryLabel} value={country} disabled={disabled || readOnly}
      className={className} style={{ ...style, width: 'auto', minWidth: 0, maxWidth: '46%', flex: '0 0 auto' }}
      onChange={event => {
        const next = event.target.value;
        setCountry(next);
        // Selecting a country alone must not fill an optional, empty phone field.
        emit(event, internationalPhone(nationalPhone(value), next));
      }}>
      {!country && <option value="" disabled>Existing code</option>}
      {PHONE_COUNTRIES.map(item => <option key={item.country} value={item.country} aria-label={item.accessibleLabel}>{item.label}</option>)}
    </select>
    <input {...props} ref={ref} type="tel" inputMode="tel" autoComplete={props.autoComplete || 'tel-national'}
      value={nationalPhone(value)} disabled={disabled} readOnly={readOnly} className={className} style={style}
      onChange={event => {
        const next = internationalPhone(event.target.value, country);
        setCountry(previous => phoneCountry(next, previous));
        emit(event, next);
      }} />
  </span>;
});
export default PhoneInput;
